
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PaymentStatusData } from "../types/payment-status";

export const usePaymentStatus = () => {
  return useQuery<PaymentStatusData[]>({
    queryKey: ['paymentStatuses'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('payment_status')
        .select(`
          id,
          status,
          amount,
          payment_date,
          time_slot:time_slots_created!time_slot_id(
            date,
            start_time,
            max_players,
            booked_players,
            paid_players,
            reserved_slots,
            reserved_paid_slots
          ),
          player:profiles_pending!player_id(
            full_name
          ),
          booking:bookings!booking_id(
            id,
            guests:guests(
              id,
              name,
              skill_level,
              gender
            )
          )
        `)
        .order('date', { foreignTable: 'time_slots_created', ascending: true })
        .order('start_time', { foreignTable: 'time_slots_created', ascending: true });

      if (error) {
        console.error('Error fetching payment statuses:', error);
        throw new Error('Failed to fetch payment statuses');
      }

      // Transform the data to match our expected types
      return (data || []).map(item => ({
        id: item.id,
        status: item.status,
        amount: item.amount,
        payment_date: item.payment_date,
        time_slot: item.time_slot,
        player: item.player,
        booking: item.booking ? {
          ...item.booking,
          guests: (item.booking.guests || []).map(guest => ({
            id: guest.id,
            name: guest.name,
            skillLevel: guest.skill_level,
            gender: guest.gender
          }))
        } : null
      })) as PaymentStatusData[];
    },
    refetchInterval: 5000,
  });
};
